/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const albumTracksModelSchema = z.object({
    "trackIds": z.array(z.string().uuid()).describe("Список треков")
    })